export const powerlabAccionesRoles = {
  sideNavActions: {
    powerLabPbi: ['Chief', 'PowerBiViewer', 'Admin'],
    testometric: [],
  },
};
